import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'

function getAllProducts(tenent) {
  return fetch(`${casaApiUrl}/users/casa-product-master/list/${tenent}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json(response)
    } else {
      return response.json(response)
    }
  })
}

export default {
  getAllProducts
}


// WEBPACK FOOTER //
// ./src/services/poduct-master-service.js